import { VariableType } from '@app/types';

export const variableTypeLabels: Record<VariableType, string> = {
  [VariableType.string]: 'String',
  [VariableType.number]: 'Number',
  [VariableType.boolean]: 'Boolean',
  [VariableType.array]: 'Array',
  [VariableType.object]: 'Object',
  [VariableType.prompt]: 'Prompt',
  [VariableType.module]: 'Module'
};
